import React from 'react';
import { useDispatch, useShallowSelector } from '@/lib/reduxHooks';
import { pasteCacheBlocks } from '@/lib/utils';
import * as actions from '../../store/senderBuild/actions';

export function usePasteBlockKeyListener() {
  const dispatch = useDispatch();
  const state = useShallowSelector((state) => ({
    envelopeId: state.senderBuild.id ?? '',
    selectedBlocks: state.senderBuild.selectedBlocks,
    blocks: state.senderBuild.blocks,
    copyCache: state.senderBuild.copyCache,
    currentDocument: state.senderBuild.currentDocument ?? '',
    currentPage: state.senderBuild.currentPage ?? 0,
    blockGroups: state.senderBuild.groups,
    pageDimensions: state.senderBuild.pageDimensions,
    inputFocused: state.senderBuild.inputFocused,
    isTextBlockEditingEnabled: state.senderBuild.isTextBlockEditingEnabled,
  }));

  React.useEffect(() => {
    function handlePaste(e: KeyboardEvent) {
      const charCode = e.key ? e.key.toLowerCase() : '';
      const { copyCache, blocks, selectedBlocks, currentDocument, currentPage, pageDimensions, inputFocused } = state;

      const pasteCommand =
        copyCache.blocks.length && ((e.metaKey && charCode === 'v') || (e.ctrlKey && charCode === 'v'));

      if (!pasteCommand || inputFocused || state.isTextBlockEditingEnabled) return;

      const { updatedGroup, blocksWithNewIds, newGroups } = pasteCacheBlocks({
        pasteCounter: state.copyCache.pasteCounter,
        copyCache,
        blocks,
        pageHeight: pageDimensions[currentDocument][currentPage].height,
        pageWidth: pageDimensions[currentDocument][currentPage].width,
        selectedBlocks,
        currentDocument,
        currentPage,
        envelopeId: state.envelopeId,
        blockGroups: state.blockGroups,
      });

      if (updatedGroup!.newBlock!.length > 0) {
        dispatch(actions.addNewBlocksToGroup(updatedGroup!.currentGroup, updatedGroup!.newBlock));
      } else {
        dispatch(actions.pasteBlocks(state.currentDocument, state.currentPage, blocksWithNewIds, newGroups));
      }
    }

    document.addEventListener('keydown', handlePaste, false);
    return () => document.removeEventListener('keydown', handlePaste, false);
  }, [dispatch, state]);
}
